export type ClientsTranslations = {
  title: string;
  subtitle: string;
  add_client: string;
  revenue_overview_title: string;
  revenue_overview_description: string;
  period_select: string;
  period_last_7_days: string;
  period_last_30_days: string;
  period_this_month: string;
  period_last_month: string;
  period_this_year: string;
  period_last_year: string;
  period_all_time: string;
  metrics_total_revenue: string;
  metrics_avg_revenue: string;
  metrics_active_clients: string;
  metrics_total_clients: string;
  metrics_no_change: string;
  metrics_vs_previous: string;
  metrics_loading: string;
  toast_load_failed: string;
  toast_delete_success_title: string;
  toast_delete_success_description: string;
  toast_delete_failed: string;
  search_placeholder: string;
  table_client: string;
  table_contact: string;
  table_location: string;
  table_total_revenue: string;
  table_status: string;
  table_loading: string;
  table_empty: string;
  table_action_view_details: string;
  table_action_edit: string;
  table_action_view_transactions: string;
  table_action_delete: string;
  delete_title: string;
  delete_description: string;
  delete_list_profile: string;
  delete_list_notes: string;
  delete_note_label: string;
  delete_note: string;
  delete_cancel: string;
  delete_confirm: string;
  status_active: string;
  status_inactive: string;
  status_pending: string;
  activity_new: string;
  activity_awaiting_invoice: string;
  activity_active_days: string;
  activity_days_ago: string;
  activity_inactive_days: string;
  details: {
    back_to_clients: string;
    edit_client: string;
    subtitle: string;
    total_revenue: string;
    open_invoices: string;
    activity_status: string;
    basic_information: string;
    client_type: string;
    client_since: string;
    company_name: string;
    last_invoice_date: string;
    type_individual: string;
    type_company: string;
    contact_information: string;
    email_address: string;
    phone_number: string;
    website: string;
    not_provided: string;
    address_title: string;
    address_location: string;
    tax_information: string;
    tax_id: string;
    notes: string;
    no_notes: string;
    recent_transactions_title: string;
    recent_transactions_description: string;
    recent_transactions_loading: string;
    recent_transactions_empty: string;
    view_all_transactions: string;
    transaction_fallback: string;
    projects_title: string;
    projects_loading: string;
    projects_count: string;
    projects_empty: string;
    add_project: string;
    project_status_active: string;
    project_status_completed: string;
    project_status_on_hold: string;
    project_status_cancelled: string;
    recent_activity_title: string;
    recent_activity_description: string;
    activity_last_invoice_title: string;
    activity_no_invoice_title: string;
    activity_no_invoice_description: string;
    activity_client_created_title: string;
    activity_days_ago: string;
    activity_pending_title: string;
    activity_pending_description: string;
    activity_inactive_description: string;
    activity_none_title: string;
    activity_none_description: string;
    activity_very_active_title: string;
    activity_active_title: string;
    activity_moderate_title: string;
    activity_low_title: string;
    activity_last_invoice_days: string;
    danger_zone_title: string;
    danger_zone_description: string;
    danger_zone_action_title: string;
    danger_zone_action_description: string;
    danger_zone_action_button: string;
  };
};

export const clientsTranslations: Record<string, ClientsTranslations> = {
  pt: {
    title: "Clientes",
    subtitle: "Gerir as relações com clientes e a receita",
    add_client: "Adicionar cliente",
    revenue_overview_title: "Visão geral de receitas",
    revenue_overview_description: "Acompanhe a receita e a atividade dos clientes",
    period_select: "Selecionar período",
    period_last_7_days: "Últimos 7 dias",
    period_last_30_days: "Últimos 30 dias",
    period_this_month: "Este mês",
    period_last_month: "Mês passado",
    period_this_year: "Este ano",
    period_last_year: "Ano passado",
    period_all_time: "Todo o período",
    metrics_total_revenue: "Receita total",
    metrics_avg_revenue: "Média por cliente",
    metrics_active_clients: "Clientes ativos",
    metrics_total_clients: "Total de clientes",
    metrics_no_change: "Sem variação",
    metrics_vs_previous: "vs. período anterior",
    metrics_loading: "A carregar...",
    toast_load_failed: "Não foi possível carregar os clientes.",
    toast_delete_success_title: "Cliente eliminado",
    toast_delete_success_description: "{{name}} foi eliminado permanentemente.",
    toast_delete_failed: "Não foi possível eliminar o cliente.",
    search_placeholder: "Pesquisar clientes por nome, email ou localização...",
    table_client: "Cliente",
    table_contact: "Contacto",
    table_location: "Localização",
    table_total_revenue: "Receita total",
    table_status: "Estado",
    table_loading: "A carregar clientes...",
    table_empty: "Ainda sem clientes. Adicione o primeiro cliente para começar.",
    table_action_view_details: "Ver detalhes",
    table_action_edit: "Editar cliente",
    table_action_view_transactions: "Ver transações",
    table_action_delete: "Eliminar cliente",
    delete_title: "Eliminar cliente?",
    delete_description: "Tem a certeza de que quer eliminar {{name}}? Esta ação é irreversível e removerá:",
    delete_list_profile: "Perfil do cliente e contactos",
    delete_list_notes: "Notas",
    delete_note_label: "Nota:",
    delete_note: "As transações bancárias serão dissociadas deste cliente mas mantidas (dados só de leitura do Open Banking).",
    delete_cancel: "Cancelar",
    delete_confirm: "Eliminar cliente",
    status_active: "Ativo",
    status_inactive: "Inativo",
    status_pending: "Pendente",
    activity_new: "Novo",
    activity_awaiting_invoice: "A aguardar primeira fatura",
    activity_active_days: "Ativo há {{count}}d",
    activity_days_ago: "{{count}}d atrás",
    activity_inactive_days: "Inativo há {{count}}d",
    details: {
      back_to_clients: "Voltar aos clientes",
      edit_client: "Editar cliente",
      subtitle: "Detalhes do cliente e histórico de transações",
      total_revenue: "Receita total",
      open_invoices: "Faturas em aberto",
      activity_status: "Estado de atividade",
      basic_information: "Informações básicas",
      client_type: "Tipo de cliente",
      client_since: "Cliente desde",
      company_name: "Nome da empresa",
      last_invoice_date: "Data da última fatura",
      type_individual: "Individual",
      type_company: "Empresa",
      contact_information: "Informações de contacto",
      email_address: "Endereço de email",
      phone_number: "Telefone",
      website: "Website",
      not_provided: "Não indicado",
      address_title: "Morada",
      address_location: "Localização",
      tax_information: "Informação fiscal",
      tax_id: "NIF / IVA",
      notes: "Notas",
      no_notes: "Sem notas",
      recent_transactions_title: "Últimas transações",
      recent_transactions_description: "Últimas 5 transações bancárias deste cliente (Open Banking)",
      recent_transactions_loading: "A carregar transações...",
      recent_transactions_empty: "Sem transações para mostrar.",
      view_all_transactions: "Ver todas",
      transaction_fallback: "Transação bancária",
      projects_title: "Projetos",
      projects_loading: "A carregar projetos...",
      projects_count: "{{count}} projeto(s) associado(s) a este cliente",
      projects_empty: "Ainda sem projetos.",
      add_project: "Adicionar projeto",
      project_status_active: "Ativo",
      project_status_completed: "Concluído",
      project_status_on_hold: "Em pausa",
      project_status_cancelled: "Cancelado",
      recent_activity_title: "Atividade recente",
      recent_activity_description: "Últimas interações e movimentos deste cliente",
      activity_last_invoice_title: "Última fatura emitida",
      activity_no_invoice_title: "Sem faturas",
      activity_no_invoice_description: "Este cliente ainda não recebeu faturas",
      activity_client_created_title: "Cliente criado",
      activity_days_ago: "{{count}} dias atrás",
      activity_pending_title: "Sem atividade ainda",
      activity_pending_description: "Cliente a aguardar primeira fatura",
      activity_inactive_description: "Cliente já não está ativo",
      activity_none_title: "Sem atividade recente",
      activity_none_description: "Sem faturas registadas",
      activity_very_active_title: "Muito ativo",
      activity_active_title: "Ativo",
      activity_moderate_title: "Atividade moderada",
      activity_low_title: "Baixa atividade",
      activity_last_invoice_days: "Última fatura há {{count}} dias",
      danger_zone_title: "Zona de perigo",
      danger_zone_description: "Ações irreversíveis que exigem atenção",
      danger_zone_action_title: "Eliminar este cliente",
      danger_zone_action_description: "Ao eliminar um cliente, não há retorno. Isto remove permanentemente o perfil, contactos e notas. As transações bancárias ficam preservadas mas dissociadas.",
      danger_zone_action_button: "Eliminar cliente",
    },
  },
  en: {
    title: "Clients",
    subtitle: "Manage your client relationships and revenue",
    add_client: "Add client",
    revenue_overview_title: "Revenue overview",
    revenue_overview_description: "Track your revenue performance and client activity",
    period_select: "Select period",
    period_last_7_days: "Last 7 days",
    period_last_30_days: "Last 30 days",
    period_this_month: "This month",
    period_last_month: "Last month",
    period_this_year: "This year",
    period_last_year: "Last year",
    period_all_time: "All time",
    metrics_total_revenue: "Total revenue",
    metrics_avg_revenue: "Avg. per client",
    metrics_active_clients: "Active clients",
    metrics_total_clients: "Total clients",
    metrics_no_change: "No change",
    metrics_vs_previous: "vs. previous",
    metrics_loading: "Loading...",
    toast_load_failed: "Failed to load clients.",
    toast_delete_success_title: "Client deleted",
    toast_delete_success_description: "{{name}} has been permanently deleted.",
    toast_delete_failed: "Failed to delete client.",
    search_placeholder: "Search clients by name, email, or location...",
    table_client: "Client",
    table_contact: "Contact",
    table_location: "Location",
    table_total_revenue: "Total revenue",
    table_status: "Status",
    table_loading: "Loading clients...",
    table_empty: "No clients yet. Add your first client to get started.",
    table_action_view_details: "View details",
    table_action_edit: "Edit client",
    table_action_view_transactions: "View transactions",
    table_action_delete: "Delete client",
    delete_title: "Delete client?",
    delete_description: "Are you sure you want to delete {{name}}? This action cannot be undone and will permanently remove:",
    delete_list_profile: "Client profile and contact information",
    delete_list_notes: "Notes",
    delete_note_label: "Note:",
    delete_note: "Bank transactions will be disassociated from this client but preserved (read-only data from Open Banking).",
    delete_cancel: "Cancel",
    delete_confirm: "Delete client",
    status_active: "Active",
    status_inactive: "Inactive",
    status_pending: "Pending",
    activity_new: "New",
    activity_awaiting_invoice: "Awaiting first invoice",
    activity_active_days: "Active {{count}}d ago",
    activity_days_ago: "{{count}}d ago",
    activity_inactive_days: "Inactive {{count}}d",
    details: {
      back_to_clients: "Back to clients",
      edit_client: "Edit client",
      subtitle: "Client details and transaction history",
      total_revenue: "Total revenue",
      open_invoices: "Open invoices",
      activity_status: "Activity status",
      basic_information: "Basic information",
      client_type: "Client type",
      client_since: "Client since",
      company_name: "Company name",
      last_invoice_date: "Last invoice date",
      type_individual: "Individual",
      type_company: "Company",
      contact_information: "Contact information",
      email_address: "Email address",
      phone_number: "Phone number",
      website: "Website",
      not_provided: "Not provided",
      address_title: "Address",
      address_location: "Location",
      tax_information: "Tax information",
      tax_id: "Tax ID / VAT number",
      notes: "Notes",
      no_notes: "No notes available",
      recent_transactions_title: "Recent transactions",
      recent_transactions_description: "Last 5 bank transactions for this client (Open Banking)",
      recent_transactions_loading: "Loading transactions...",
      recent_transactions_empty: "No transactions to show.",
      view_all_transactions: "View all",
      transaction_fallback: "Bank transaction",
      projects_title: "Projects",
      projects_loading: "Loading projects...",
      projects_count: "{{count}} project(s) associated with this client",
      projects_empty: "No projects yet.",
      add_project: "Add project",
      project_status_active: "Active",
      project_status_completed: "Completed",
      project_status_on_hold: "On hold",
      project_status_cancelled: "Cancelled",
      recent_activity_title: "Recent activity",
      recent_activity_description: "Latest interactions and movements for this client",
      activity_last_invoice_title: "Last invoice issued",
      activity_no_invoice_title: "No invoices yet",
      activity_no_invoice_description: "This client hasn't received any invoices yet",
      activity_client_created_title: "Client created",
      activity_days_ago: "{{count}} days ago",
      activity_pending_title: "No activity yet",
      activity_pending_description: "Client is pending first invoice",
      activity_inactive_description: "Client is no longer active",
      activity_none_title: "No recent activity",
      activity_none_description: "No invoices recorded",
      activity_very_active_title: "Very active",
      activity_active_title: "Active",
      activity_moderate_title: "Moderate activity",
      activity_low_title: "Low activity",
      activity_last_invoice_days: "Last invoice {{count}} days ago",
      danger_zone_title: "Danger zone",
      danger_zone_description: "Irreversible actions that require careful consideration",
      danger_zone_action_title: "Delete this client",
      danger_zone_action_description: "Once you delete a client, there is no going back. This will permanently remove the client profile, contact information, and notes. Bank transactions will be preserved but disassociated.",
      danger_zone_action_button: "Delete client",
    },
  },
  es: {
    title: "Clientes",
    subtitle: "Gestiona tus relaciones con clientes y los ingresos",
    add_client: "Añadir cliente",
    revenue_overview_title: "Resumen de ingresos",
    revenue_overview_description: "Sigue el rendimiento de ingresos y la actividad de clientes",
    period_select: "Seleccionar periodo",
    period_last_7_days: "Últimos 7 días",
    period_last_30_days: "Últimos 30 días",
    period_this_month: "Este mes",
    period_last_month: "Mes pasado",
    period_this_year: "Este año",
    period_last_year: "Año pasado",
    period_all_time: "Todo el tiempo",
    metrics_total_revenue: "Ingresos totales",
    metrics_avg_revenue: "Media por cliente",
    metrics_active_clients: "Clientes activos",
    metrics_total_clients: "Total de clientes",
    metrics_no_change: "Sin cambios",
    metrics_vs_previous: "vs. anterior",
    metrics_loading: "Cargando...",
    toast_load_failed: "No se pudieron cargar los clientes.",
    toast_delete_success_title: "Cliente eliminado",
    toast_delete_success_description: "{{name}} se ha eliminado permanentemente.",
    toast_delete_failed: "No se pudo eliminar el cliente.",
    search_placeholder: "Buscar clientes por nombre, email o ubicación...",
    table_client: "Cliente",
    table_contact: "Contacto",
    table_location: "Ubicación",
    table_total_revenue: "Ingresos totales",
    table_status: "Estado",
    table_loading: "Cargando clientes...",
    table_empty: "Aún no hay clientes. Añade el primero para comenzar.",
    table_action_view_details: "Ver detalles",
    table_action_edit: "Editar cliente",
    table_action_view_transactions: "Ver transacciones",
    table_action_delete: "Eliminar cliente",
    delete_title: "¿Eliminar cliente?",
    delete_description: "¿Seguro que quieres eliminar a {{name}}? Esta acción es irreversible y eliminará:",
    delete_list_profile: "Perfil del cliente y contacto",
    delete_list_notes: "Notas",
    delete_note_label: "Nota:",
    delete_note: "Las transacciones bancarias se desvincularán de este cliente pero se conservarán (datos de solo lectura de Open Banking).",
    delete_cancel: "Cancelar",
    delete_confirm: "Eliminar cliente",
    status_active: "Activo",
    status_inactive: "Inactivo",
    status_pending: "Pendiente",
    activity_new: "Nuevo",
    activity_awaiting_invoice: "Esperando primera factura",
    activity_active_days: "Activo hace {{count}}d",
    activity_days_ago: "Hace {{count}}d",
    activity_inactive_days: "Inactivo {{count}}d",
    details: {
      back_to_clients: "Volver a clientes",
      edit_client: "Editar cliente",
      subtitle: "Detalles del cliente e historial de transacciones",
      total_revenue: "Ingresos totales",
      open_invoices: "Facturas abiertas",
      activity_status: "Estado de actividad",
      basic_information: "Información básica",
      client_type: "Tipo de cliente",
      client_since: "Cliente desde",
      company_name: "Nombre de la empresa",
      last_invoice_date: "Fecha de la última factura",
      type_individual: "Individual",
      type_company: "Empresa",
      contact_information: "Información de contacto",
      email_address: "Correo electrónico",
      phone_number: "Teléfono",
      website: "Sitio web",
      not_provided: "No indicado",
      address_title: "Dirección",
      address_location: "Ubicación",
      tax_information: "Información fiscal",
      tax_id: "NIF / IVA",
      notes: "Notas",
      no_notes: "Sin notas",
      recent_transactions_title: "Transacciones recientes",
      recent_transactions_description: "Últimas 5 transacciones bancarias de este cliente (Open Banking)",
      recent_transactions_loading: "Cargando transacciones...",
      recent_transactions_empty: "No hay transacciones para mostrar.",
      view_all_transactions: "Ver todas",
      transaction_fallback: "Transacción bancaria",
      projects_title: "Proyectos",
      projects_loading: "Cargando proyectos...",
      projects_count: "{{count}} proyecto(s) asociados a este cliente",
      projects_empty: "Aún no hay proyectos.",
      add_project: "Añadir proyecto",
      project_status_active: "Activo",
      project_status_completed: "Completado",
      project_status_on_hold: "En pausa",
      project_status_cancelled: "Cancelado",
      recent_activity_title: "Actividad reciente",
      recent_activity_description: "Últimas interacciones y movimientos del cliente",
      activity_last_invoice_title: "Última factura emitida",
      activity_no_invoice_title: "Sin facturas",
      activity_no_invoice_description: "Este cliente aún no ha recibido facturas",
      activity_client_created_title: "Cliente creado",
      activity_days_ago: "Hace {{count}} días",
      activity_pending_title: "Sin actividad aún",
      activity_pending_description: "Cliente pendiente de primera factura",
      activity_inactive_description: "El cliente ya no está activo",
      activity_none_title: "Sin actividad reciente",
      activity_none_description: "No hay facturas registradas",
      activity_very_active_title: "Muy activo",
      activity_active_title: "Activo",
      activity_moderate_title: "Actividad moderada",
      activity_low_title: "Baja actividad",
      activity_last_invoice_days: "Última factura hace {{count}} días",
      danger_zone_title: "Zona de riesgo",
      danger_zone_description: "Acciones irreversibles que requieren atención",
      danger_zone_action_title: "Eliminar este cliente",
      danger_zone_action_description: "Al eliminar un cliente no hay vuelta atrás. Se eliminará permanentemente el perfil, la información de contacto y las notas. Las transacciones bancarias se conservarán pero se desvincularán.",
      danger_zone_action_button: "Eliminar cliente",
    },
  },
  et: {
    title: "Kliendid",
    subtitle: "Halda kliendisuhteid ja tulu",
    add_client: "Lisa klient",
    revenue_overview_title: "Tulude ülevaade",
    revenue_overview_description: "Jälgi tulude tulemust ja kliendi aktiivsust",
    period_select: "Vali periood",
    period_last_7_days: "Viimased 7 päeva",
    period_last_30_days: "Viimased 30 päeva",
    period_this_month: "See kuu",
    period_last_month: "Eelmine kuu",
    period_this_year: "See aasta",
    period_last_year: "Eelmine aasta",
    period_all_time: "Kogu periood",
    metrics_total_revenue: "Kogutulu",
    metrics_avg_revenue: "Keskmine kliendi kohta",
    metrics_active_clients: "Aktiivsed kliendid",
    metrics_total_clients: "Kokku kliendid",
    metrics_no_change: "Muutus puudub",
    metrics_vs_previous: "vs eelmine",
    metrics_loading: "Laadimine...",
    toast_load_failed: "Klientide laadimine ebaõnnestus.",
    toast_delete_success_title: "Klient kustutatud",
    toast_delete_success_description: "{{name}} on jäädavalt kustutatud.",
    toast_delete_failed: "Kliendi kustutamine ebaõnnestus.",
    search_placeholder: "Otsi kliente nime, e-posti või asukoha järgi...",
    table_client: "Klient",
    table_contact: "Kontakt",
    table_location: "Asukoht",
    table_total_revenue: "Kogutulu",
    table_status: "Staatus",
    table_loading: "Klientide laadimine...",
    table_empty: "Kliente pole. Lisa esimene klient alustamiseks.",
    table_action_view_details: "Vaata detaile",
    table_action_edit: "Muuda klient",
    table_action_view_transactions: "Vaata tehinguid",
    table_action_delete: "Kustuta klient",
    delete_title: "Kustuta klient?",
    delete_description: "Kas soovid {{name}} kustutada? See toiming on pöördumatu ja eemaldab:",
    delete_list_profile: "Kliendi profiili ja kontaktinfo",
    delete_list_notes: "Märkmed",
    delete_note_label: "Märkus:",
    delete_note: "Pangatehingud eemaldatakse kliendilt, kuid säilitatakse (ainult lugemiseks Open Banking).",
    delete_cancel: "Tühista",
    delete_confirm: "Kustuta klient",
    status_active: "Aktiivne",
    status_inactive: "Mitteaktiivne",
    status_pending: "Ootel",
    activity_new: "Uus",
    activity_awaiting_invoice: "Ootab esimest arvet",
    activity_active_days: "Aktiivne {{count}}p tagasi",
    activity_days_ago: "{{count}}p tagasi",
    activity_inactive_days: "Mitteaktiivne {{count}}p",
    details: {
      back_to_clients: "Tagasi klientide juurde",
      edit_client: "Muuda klient",
      subtitle: "Kliendi detailid ja tehingute ajalugu",
      total_revenue: "Kogutulu",
      open_invoices: "Avatud arved",
      activity_status: "Aktiivsuse staatus",
      basic_information: "Põhiinfo",
      client_type: "Kliendi tüüp",
      client_since: "Klient alates",
      company_name: "Ettevõtte nimi",
      last_invoice_date: "Viimase arve kuupäev",
      type_individual: "Eraisik",
      type_company: "Ettevõte",
      contact_information: "Kontaktandmed",
      email_address: "E-posti aadress",
      phone_number: "Telefon",
      website: "Veebileht",
      not_provided: "Pole esitatud",
      address_title: "Aadress",
      address_location: "Asukoht",
      tax_information: "Maksuinfo",
      tax_id: "Maksukood / KM",
      notes: "Märkmed",
      no_notes: "Märkmed puuduvad",
      recent_transactions_title: "Viimased tehingud",
      recent_transactions_description: "Viimased 5 pangatehingut selle kliendi kohta (Open Banking)",
      recent_transactions_loading: "Tehingute laadimine...",
      recent_transactions_empty: "Tehinguid pole.",
      view_all_transactions: "Vaata kõiki",
      transaction_fallback: "Pangatehing",
      projects_title: "Projektid",
      projects_loading: "Projektide laadimine...",
      projects_count: "{{count}} projekt(i) seotud kliendiga",
      projects_empty: "Projekte pole.",
      add_project: "Lisa projekt",
      project_status_active: "Aktiivne",
      project_status_completed: "Lõpetatud",
      project_status_on_hold: "Pausil",
      project_status_cancelled: "Tühistatud",
      recent_activity_title: "Hiljutine tegevus",
      recent_activity_description: "Viimased kliendi interaktsioonid ja liikumised",
      activity_last_invoice_title: "Viimane arve",
      activity_no_invoice_title: "Arveid pole",
      activity_no_invoice_description: "Sellele kliendile pole arveid väljastatud",
      activity_client_created_title: "Klient loodud",
      activity_days_ago: "{{count}} päeva tagasi",
      activity_pending_title: "Tegevus puudub",
      activity_pending_description: "Klient ootab esimest arvet",
      activity_inactive_description: "Klient ei ole enam aktiivne",
      activity_none_title: "Hiljutine tegevus puudub",
      activity_none_description: "Arveid pole salvestatud",
      activity_very_active_title: "Väga aktiivne",
      activity_active_title: "Aktiivne",
      activity_moderate_title: "Mõõdukas aktiivsus",
      activity_low_title: "Vähene aktiivsus",
      activity_last_invoice_days: "Viimane arve {{count}} päeva tagasi",
      danger_zone_title: "Ohtlik ala",
      danger_zone_description: "Pöördumatud toimingud, mis nõuavad tähelepanu",
      danger_zone_action_title: "Kustuta klient",
      danger_zone_action_description: "Kliendi kustutamine on pöördumatu. See eemaldab profiili, kontaktinfo ja märkmed. Pangatehingud säilitatakse, kuid seotakse lahti.",
      danger_zone_action_button: "Kustuta klient",
    },
  },
  de: {
    title: "Kunden",
    subtitle: "Verwalten Sie Ihre Kundenbeziehungen und Umsätze",
    add_client: "Kunden hinzufügen",
    revenue_overview_title: "Umsatzübersicht",
    revenue_overview_description: "Verfolgen Sie Umsatz und Kundenaktivität",
    period_select: "Zeitraum wählen",
    period_last_7_days: "Letzte 7 Tage",
    period_last_30_days: "Letzte 30 Tage",
    period_this_month: "Diesen Monat",
    period_last_month: "Letzten Monat",
    period_this_year: "Dieses Jahr",
    period_last_year: "Letztes Jahr",
    period_all_time: "Gesamter Zeitraum",
    metrics_total_revenue: "Gesamtumsatz",
    metrics_avg_revenue: "Durchschnitt pro Kunde",
    metrics_active_clients: "Aktive Kunden",
    metrics_total_clients: "Kunden gesamt",
    metrics_no_change: "Keine Änderung",
    metrics_vs_previous: "ggü. vorher",
    metrics_loading: "Wird geladen...",
    toast_load_failed: "Kunden konnten nicht geladen werden.",
    toast_delete_success_title: "Kunde gelöscht",
    toast_delete_success_description: "{{name}} wurde dauerhaft gelöscht.",
    toast_delete_failed: "Kunde konnte nicht gelöscht werden.",
    search_placeholder: "Kunden nach Name, E-Mail oder Ort suchen...",
    table_client: "Kunde",
    table_contact: "Kontakt",
    table_location: "Ort",
    table_total_revenue: "Gesamtumsatz",
    table_status: "Status",
    table_loading: "Kunden werden geladen...",
    table_empty: "Noch keine Kunden. Fügen Sie den ersten Kunden hinzu.",
    table_action_view_details: "Details ansehen",
    table_action_edit: "Kunden bearbeiten",
    table_action_view_transactions: "Transaktionen ansehen",
    table_action_delete: "Kunden löschen",
    delete_title: "Kunden löschen?",
    delete_description: "Möchten Sie {{name}} wirklich löschen? Diese Aktion ist unwiderruflich und entfernt:",
    delete_list_profile: "Kundenprofil und Kontaktinformationen",
    delete_list_notes: "Notizen",
    delete_note_label: "Hinweis:",
    delete_note: "Banktransaktionen werden vom Kunden getrennt, bleiben aber erhalten (schreibgeschützte Open-Banking-Daten).",
    delete_cancel: "Abbrechen",
    delete_confirm: "Kunden löschen",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    status_pending: "Ausstehend",
    activity_new: "Neu",
    activity_awaiting_invoice: "Wartet auf erste Rechnung",
    activity_active_days: "Aktiv vor {{count}}T",
    activity_days_ago: "Vor {{count}}T",
    activity_inactive_days: "Inaktiv {{count}}T",
    details: {
      back_to_clients: "Zurück zu Kunden",
      edit_client: "Kunden bearbeiten",
      subtitle: "Kundendetails und Transaktionsverlauf",
      total_revenue: "Gesamtumsatz",
      open_invoices: "Offene Rechnungen",
      activity_status: "Aktivitätsstatus",
      basic_information: "Grundinformationen",
      client_type: "Kundentyp",
      client_since: "Kunde seit",
      company_name: "Firmenname",
      last_invoice_date: "Letzte Rechnungsdatum",
      type_individual: "Privat",
      type_company: "Firma",
      contact_information: "Kontaktinformationen",
      email_address: "E-Mail-Adresse",
      phone_number: "Telefonnummer",
      website: "Webseite",
      not_provided: "Nicht angegeben",
      address_title: "Adresse",
      address_location: "Ort",
      tax_information: "Steuerinformationen",
      tax_id: "Steuernummer / USt",
      notes: "Notizen",
      no_notes: "Keine Notizen",
      recent_transactions_title: "Letzte Transaktionen",
      recent_transactions_description: "Letzte 5 Banktransaktionen dieses Kunden (Open Banking)",
      recent_transactions_loading: "Transaktionen werden geladen...",
      recent_transactions_empty: "Keine Transaktionen vorhanden.",
      view_all_transactions: "Alle anzeigen",
      transaction_fallback: "Banktransaktion",
      projects_title: "Projekte",
      projects_loading: "Projekte werden geladen...",
      projects_count: "{{count}} Projekt(e) diesem Kunden zugeordnet",
      projects_empty: "Noch keine Projekte.",
      add_project: "Projekt hinzufügen",
      project_status_active: "Aktiv",
      project_status_completed: "Abgeschlossen",
      project_status_on_hold: "Pausiert",
      project_status_cancelled: "Storniert",
      recent_activity_title: "Letzte Aktivität",
      recent_activity_description: "Letzte Interaktionen und Bewegungen dieses Kunden",
      activity_last_invoice_title: "Letzte Rechnung",
      activity_no_invoice_title: "Keine Rechnungen",
      activity_no_invoice_description: "Dieser Kunde hat noch keine Rechnungen erhalten",
      activity_client_created_title: "Kunde erstellt",
      activity_days_ago: "Vor {{count}} Tagen",
      activity_pending_title: "Noch keine Aktivität",
      activity_pending_description: "Kunde wartet auf erste Rechnung",
      activity_inactive_description: "Kunde ist nicht mehr aktiv",
      activity_none_title: "Keine aktuelle Aktivität",
      activity_none_description: "Keine Rechnungen erfasst",
      activity_very_active_title: "Sehr aktiv",
      activity_active_title: "Aktiv",
      activity_moderate_title: "Mäßige Aktivität",
      activity_low_title: "Geringe Aktivität",
      activity_last_invoice_days: "Letzte Rechnung vor {{count}} Tagen",
      danger_zone_title: "Gefahrenzone",
      danger_zone_description: "Unumkehrbare Aktionen, die Aufmerksamkeit erfordern",
      danger_zone_action_title: "Kunden löschen",
      danger_zone_action_description: "Beim Löschen eines Kunden gibt es kein Zurück. Profil, Kontaktinformationen und Notizen werden dauerhaft entfernt. Banktransaktionen bleiben erhalten, werden aber getrennt.",
      danger_zone_action_button: "Kunden löschen",
    },
  },
  fr: {
    title: "Clients",
    subtitle: "Gérez vos relations clients et votre chiffre d'affaires",
    add_client: "Ajouter un client",
    revenue_overview_title: "Vue d'ensemble des revenus",
    revenue_overview_description: "Suivez les revenus et l'activité des clients",
    period_select: "Sélectionner la période",
    period_last_7_days: "7 derniers jours",
    period_last_30_days: "30 derniers jours",
    period_this_month: "Ce mois-ci",
    period_last_month: "Mois dernier",
    period_this_year: "Cette année",
    period_last_year: "L'année dernière",
    period_all_time: "Depuis le début",
    metrics_total_revenue: "Revenu total",
    metrics_avg_revenue: "Moyenne par client",
    metrics_active_clients: "Clients actifs",
    metrics_total_clients: "Total des clients",
    metrics_no_change: "Aucun changement",
    metrics_vs_previous: "vs précédent",
    metrics_loading: "Chargement...",
    toast_load_failed: "Impossible de charger les clients.",
    toast_delete_success_title: "Client supprimé",
    toast_delete_success_description: "{{name}} a été supprimé définitivement.",
    toast_delete_failed: "Impossible de supprimer le client.",
    search_placeholder: "Rechercher des clients par nom, email ou lieu...",
    table_client: "Client",
    table_contact: "Contact",
    table_location: "Localisation",
    table_total_revenue: "Revenu total",
    table_status: "Statut",
    table_loading: "Chargement des clients...",
    table_empty: "Aucun client. Ajoutez le premier pour commencer.",
    table_action_view_details: "Voir les détails",
    table_action_edit: "Modifier le client",
    table_action_view_transactions: "Voir les transactions",
    table_action_delete: "Supprimer le client",
    delete_title: "Supprimer le client ?",
    delete_description: "Voulez-vous vraiment supprimer {{name}} ? Cette action est irréversible et supprimera :",
    delete_list_profile: "Profil du client et informations de contact",
    delete_list_notes: "Notes",
    delete_note_label: "Note :",
    delete_note: "Les transactions bancaires seront dissociées de ce client mais conservées (données Open Banking en lecture seule).",
    delete_cancel: "Annuler",
    delete_confirm: "Supprimer le client",
    status_active: "Actif",
    status_inactive: "Inactif",
    status_pending: "En attente",
    activity_new: "Nouveau",
    activity_awaiting_invoice: "En attente de la première facture",
    activity_active_days: "Actif il y a {{count}}j",
    activity_days_ago: "Il y a {{count}}j",
    activity_inactive_days: "Inactif {{count}}j",
    details: {
      back_to_clients: "Retour aux clients",
      edit_client: "Modifier le client",
      subtitle: "Détails du client et historique des transactions",
      total_revenue: "Revenu total",
      open_invoices: "Factures ouvertes",
      activity_status: "Statut d'activité",
      basic_information: "Informations de base",
      client_type: "Type de client",
      client_since: "Client depuis",
      company_name: "Nom de l'entreprise",
      last_invoice_date: "Date de la dernière facture",
      type_individual: "Individuel",
      type_company: "Entreprise",
      contact_information: "Informations de contact",
      email_address: "Adresse e-mail",
      phone_number: "Téléphone",
      website: "Site web",
      not_provided: "Non fourni",
      address_title: "Adresse",
      address_location: "Localisation",
      tax_information: "Informations fiscales",
      tax_id: "Numéro fiscal / TVA",
      notes: "Notes",
      no_notes: "Aucune note",
      recent_transactions_title: "Transactions récentes",
      recent_transactions_description: "Les 5 dernières transactions bancaires de ce client (Open Banking)",
      recent_transactions_loading: "Chargement des transactions...",
      recent_transactions_empty: "Aucune transaction à afficher.",
      view_all_transactions: "Voir tout",
      transaction_fallback: "Transaction bancaire",
      projects_title: "Projets",
      projects_loading: "Chargement des projets...",
      projects_count: "{{count}} projet(s) associé(s) à ce client",
      projects_empty: "Aucun projet.",
      add_project: "Ajouter un projet",
      project_status_active: "Actif",
      project_status_completed: "Terminé",
      project_status_on_hold: "En pause",
      project_status_cancelled: "Annulé",
      recent_activity_title: "Activité récente",
      recent_activity_description: "Dernières interactions et mouvements de ce client",
      activity_last_invoice_title: "Dernière facture émise",
      activity_no_invoice_title: "Aucune facture",
      activity_no_invoice_description: "Ce client n'a pas encore reçu de factures",
      activity_client_created_title: "Client créé",
      activity_days_ago: "Il y a {{count}} jours",
      activity_pending_title: "Aucune activité",
      activity_pending_description: "Client en attente de la première facture",
      activity_inactive_description: "Le client n'est plus actif",
      activity_none_title: "Aucune activité récente",
      activity_none_description: "Aucune facture enregistrée",
      activity_very_active_title: "Très actif",
      activity_active_title: "Actif",
      activity_moderate_title: "Activité modérée",
      activity_low_title: "Faible activité",
      activity_last_invoice_days: "Dernière facture il y a {{count}} jours",
      danger_zone_title: "Zone sensible",
      danger_zone_description: "Actions irréversibles nécessitant attention",
      danger_zone_action_title: "Supprimer ce client",
      danger_zone_action_description: "Supprimer un client est irréversible. Le profil, les contacts et les notes seront supprimés. Les transactions bancaires seront conservées mais dissociées.",
      danger_zone_action_button: "Supprimer le client",
    },
  },
  it: {
    title: "Clienti",
    subtitle: "Gestisci le relazioni con i clienti e i ricavi",
    add_client: "Aggiungi cliente",
    revenue_overview_title: "Panoramica ricavi",
    revenue_overview_description: "Monitora ricavi e attività dei clienti",
    period_select: "Seleziona periodo",
    period_last_7_days: "Ultimi 7 giorni",
    period_last_30_days: "Ultimi 30 giorni",
    period_this_month: "Questo mese",
    period_last_month: "Mese scorso",
    period_this_year: "Quest'anno",
    period_last_year: "Anno scorso",
    period_all_time: "Tutto il periodo",
    metrics_total_revenue: "Ricavi totali",
    metrics_avg_revenue: "Media per cliente",
    metrics_active_clients: "Clienti attivi",
    metrics_total_clients: "Clienti totali",
    metrics_no_change: "Nessuna variazione",
    metrics_vs_previous: "vs precedente",
    metrics_loading: "Caricamento...",
    toast_load_failed: "Impossibile caricare i clienti.",
    toast_delete_success_title: "Cliente eliminato",
    toast_delete_success_description: "{{name}} è stato eliminato definitivamente.",
    toast_delete_failed: "Impossibile eliminare il cliente.",
    search_placeholder: "Cerca clienti per nome, email o località...",
    table_client: "Cliente",
    table_contact: "Contatto",
    table_location: "Località",
    table_total_revenue: "Ricavi totali",
    table_status: "Stato",
    table_loading: "Caricamento clienti...",
    table_empty: "Nessun cliente. Aggiungi il primo per iniziare.",
    table_action_view_details: "Vedi dettagli",
    table_action_edit: "Modifica cliente",
    table_action_view_transactions: "Vedi transazioni",
    table_action_delete: "Elimina cliente",
    delete_title: "Eliminare il cliente?",
    delete_description: "Vuoi eliminare {{name}}? Questa azione è irreversibile e rimuoverà:",
    delete_list_profile: "Profilo cliente e contatti",
    delete_list_notes: "Note",
    delete_note_label: "Nota:",
    delete_note: "Le transazioni bancarie saranno dissociate da questo cliente ma mantenute (dati di sola lettura Open Banking).",
    delete_cancel: "Annulla",
    delete_confirm: "Elimina cliente",
    status_active: "Attivo",
    status_inactive: "Inattivo",
    status_pending: "In sospeso",
    activity_new: "Nuovo",
    activity_awaiting_invoice: "In attesa della prima fattura",
    activity_active_days: "Attivo {{count}}g fa",
    activity_days_ago: "{{count}}g fa",
    activity_inactive_days: "Inattivo {{count}}g",
    details: {
      back_to_clients: "Torna ai clienti",
      edit_client: "Modifica cliente",
      subtitle: "Dettagli cliente e storico transazioni",
      total_revenue: "Ricavi totali",
      open_invoices: "Fatture aperte",
      activity_status: "Stato attività",
      basic_information: "Informazioni di base",
      client_type: "Tipo di cliente",
      client_since: "Cliente dal",
      company_name: "Nome azienda",
      last_invoice_date: "Data ultima fattura",
      type_individual: "Individuale",
      type_company: "Azienda",
      contact_information: "Informazioni di contatto",
      email_address: "Email",
      phone_number: "Telefono",
      website: "Sito web",
      not_provided: "Non fornito",
      address_title: "Indirizzo",
      address_location: "Località",
      tax_information: "Informazioni fiscali",
      tax_id: "Codice fiscale / IVA",
      notes: "Note",
      no_notes: "Nessuna nota",
      recent_transactions_title: "Transazioni recenti",
      recent_transactions_description: "Ultime 5 transazioni bancarie di questo cliente (Open Banking)",
      recent_transactions_loading: "Caricamento transazioni...",
      recent_transactions_empty: "Nessuna transazione da mostrare.",
      view_all_transactions: "Vedi tutte",
      transaction_fallback: "Transazione bancaria",
      projects_title: "Progetti",
      projects_loading: "Caricamento progetti...",
      projects_count: "{{count}} progetto/i associato/i a questo cliente",
      projects_empty: "Nessun progetto.",
      add_project: "Aggiungi progetto",
      project_status_active: "Attivo",
      project_status_completed: "Completato",
      project_status_on_hold: "In pausa",
      project_status_cancelled: "Annullato",
      recent_activity_title: "Attività recente",
      recent_activity_description: "Ultime interazioni e movimenti del cliente",
      activity_last_invoice_title: "Ultima fattura emessa",
      activity_no_invoice_title: "Nessuna fattura",
      activity_no_invoice_description: "Questo cliente non ha ancora ricevuto fatture",
      activity_client_created_title: "Cliente creato",
      activity_days_ago: "{{count}} giorni fa",
      activity_pending_title: "Nessuna attività",
      activity_pending_description: "Cliente in attesa della prima fattura",
      activity_inactive_description: "Il cliente non è più attivo",
      activity_none_title: "Nessuna attività recente",
      activity_none_description: "Nessuna fattura registrata",
      activity_very_active_title: "Molto attivo",
      activity_active_title: "Attivo",
      activity_moderate_title: "Attività moderata",
      activity_low_title: "Bassa attività",
      activity_last_invoice_days: "Ultima fattura {{count}} giorni fa",
      danger_zone_title: "Zona pericolosa",
      danger_zone_description: "Azioni irreversibili che richiedono attenzione",
      danger_zone_action_title: "Elimina questo cliente",
      danger_zone_action_description: "L'eliminazione è irreversibile. Verranno rimossi profilo, contatti e note. Le transazioni bancarie saranno conservate ma dissociate.",
      danger_zone_action_button: "Elimina cliente",
    },
  },
  nl: {
    title: "Klanten",
    subtitle: "Beheer je klantrelaties en omzet",
    add_client: "Klant toevoegen",
    revenue_overview_title: "Omzetoverzicht",
    revenue_overview_description: "Volg omzet en klantactiviteit",
    period_select: "Periode selecteren",
    period_last_7_days: "Laatste 7 dagen",
    period_last_30_days: "Laatste 30 dagen",
    period_this_month: "Deze maand",
    period_last_month: "Vorige maand",
    period_this_year: "Dit jaar",
    period_last_year: "Vorig jaar",
    period_all_time: "Alle tijd",
    metrics_total_revenue: "Totale omzet",
    metrics_avg_revenue: "Gemiddeld per klant",
    metrics_active_clients: "Actieve klanten",
    metrics_total_clients: "Totaal klanten",
    metrics_no_change: "Geen verandering",
    metrics_vs_previous: "t.o.v. vorige",
    metrics_loading: "Laden...",
    toast_load_failed: "Klanten laden is mislukt.",
    toast_delete_success_title: "Klant verwijderd",
    toast_delete_success_description: "{{name}} is definitief verwijderd.",
    toast_delete_failed: "Klant verwijderen is mislukt.",
    search_placeholder: "Zoek klanten op naam, e-mail of locatie...",
    table_client: "Klant",
    table_contact: "Contact",
    table_location: "Locatie",
    table_total_revenue: "Totale omzet",
    table_status: "Status",
    table_loading: "Klanten laden...",
    table_empty: "Nog geen klanten. Voeg de eerste klant toe.",
    table_action_view_details: "Details bekijken",
    table_action_edit: "Klant bewerken",
    table_action_view_transactions: "Transacties bekijken",
    table_action_delete: "Klant verwijderen",
    delete_title: "Klant verwijderen?",
    delete_description: "Weet je zeker dat je {{name}} wilt verwijderen? Dit is onomkeerbaar en verwijdert:",
    delete_list_profile: "Klantprofiel en contactinformatie",
    delete_list_notes: "Notities",
    delete_note_label: "Let op:",
    delete_note: "Banktransacties worden losgekoppeld van deze klant maar blijven bewaard (alleen-lezen Open Banking-gegevens).",
    delete_cancel: "Annuleren",
    delete_confirm: "Klant verwijderen",
    status_active: "Actief",
    status_inactive: "Inactief",
    status_pending: "In afwachting",
    activity_new: "Nieuw",
    activity_awaiting_invoice: "Wacht op eerste factuur",
    activity_active_days: "Actief {{count}}d geleden",
    activity_days_ago: "{{count}}d geleden",
    activity_inactive_days: "Inactief {{count}}d",
    details: {
      back_to_clients: "Terug naar klanten",
      edit_client: "Klant bewerken",
      subtitle: "Klantdetails en transacties",
      total_revenue: "Totale omzet",
      open_invoices: "Openstaande facturen",
      activity_status: "Activiteitsstatus",
      basic_information: "Basisinformatie",
      client_type: "Klanttype",
      client_since: "Klant sinds",
      company_name: "Bedrijfsnaam",
      last_invoice_date: "Datum laatste factuur",
      type_individual: "Individueel",
      type_company: "Bedrijf",
      contact_information: "Contactinformatie",
      email_address: "E-mailadres",
      phone_number: "Telefoonnummer",
      website: "Website",
      not_provided: "Niet opgegeven",
      address_title: "Adres",
      address_location: "Locatie",
      tax_information: "Belastinginformatie",
      tax_id: "BTW-nummer",
      notes: "Notities",
      no_notes: "Geen notities",
      recent_transactions_title: "Recente transacties",
      recent_transactions_description: "Laatste 5 banktransacties van deze klant (Open Banking)",
      recent_transactions_loading: "Transacties laden...",
      recent_transactions_empty: "Geen transacties om te tonen.",
      view_all_transactions: "Bekijk alle",
      transaction_fallback: "Banktransactie",
      projects_title: "Projecten",
      projects_loading: "Projecten laden...",
      projects_count: "{{count}} project(en) gekoppeld aan deze klant",
      projects_empty: "Nog geen projecten.",
      add_project: "Project toevoegen",
      project_status_active: "Actief",
      project_status_completed: "Voltooid",
      project_status_on_hold: "On hold",
      project_status_cancelled: "Geannuleerd",
      recent_activity_title: "Recente activiteit",
      recent_activity_description: "Laatste interacties en bewegingen van deze klant",
      activity_last_invoice_title: "Laatste factuur",
      activity_no_invoice_title: "Geen facturen",
      activity_no_invoice_description: "Deze klant heeft nog geen facturen ontvangen",
      activity_client_created_title: "Klant aangemaakt",
      activity_days_ago: "{{count}} dagen geleden",
      activity_pending_title: "Nog geen activiteit",
      activity_pending_description: "Klant wacht op eerste factuur",
      activity_inactive_description: "Klant is niet langer actief",
      activity_none_title: "Geen recente activiteit",
      activity_none_description: "Geen facturen geregistreerd",
      activity_very_active_title: "Zeer actief",
      activity_active_title: "Actief",
      activity_moderate_title: "Matige activiteit",
      activity_low_title: "Lage activiteit",
      activity_last_invoice_days: "Laatste factuur {{count}} dagen geleden",
      danger_zone_title: "Gevarenzone",
      danger_zone_description: "Onomkeerbare acties die aandacht vereisen",
      danger_zone_action_title: "Deze klant verwijderen",
      danger_zone_action_description: "Verwijderen is onomkeerbaar. Profiel, contactinformatie en notities worden verwijderd. Banktransacties blijven bewaard maar worden losgekoppeld.",
      danger_zone_action_button: "Klant verwijderen",
    },
  },
  sv: {
    title: "Kunder",
    subtitle: "Hantera kundrelationer och intäkter",
    add_client: "Lägg till kund",
    revenue_overview_title: "Intäktsöversikt",
    revenue_overview_description: "Följ intäkter och kundaktivitet",
    period_select: "Välj period",
    period_last_7_days: "Senaste 7 dagarna",
    period_last_30_days: "Senaste 30 dagarna",
    period_this_month: "Denna månad",
    period_last_month: "Förra månaden",
    period_this_year: "I år",
    period_last_year: "Förra året",
    period_all_time: "Hela perioden",
    metrics_total_revenue: "Totala intäkter",
    metrics_avg_revenue: "Snitt per kund",
    metrics_active_clients: "Aktiva kunder",
    metrics_total_clients: "Totalt antal kunder",
    metrics_no_change: "Ingen förändring",
    metrics_vs_previous: "jämfört med tidigare",
    metrics_loading: "Laddar...",
    toast_load_failed: "Kunde inte läsa in kunder.",
    toast_delete_success_title: "Kund borttagen",
    toast_delete_success_description: "{{name}} har tagits bort permanent.",
    toast_delete_failed: "Kunde inte ta bort kunden.",
    search_placeholder: "Sök kunder efter namn, e-post eller plats...",
    table_client: "Kund",
    table_contact: "Kontakt",
    table_location: "Plats",
    table_total_revenue: "Totala intäkter",
    table_status: "Status",
    table_loading: "Laddar kunder...",
    table_empty: "Inga kunder ännu. Lägg till den första kunden.",
    table_action_view_details: "Visa detaljer",
    table_action_edit: "Redigera kund",
    table_action_view_transactions: "Visa transaktioner",
    table_action_delete: "Ta bort kund",
    delete_title: "Ta bort kund?",
    delete_description: "Är du säker på att du vill ta bort {{name}}? Detta kan inte ångras och tar bort:",
    delete_list_profile: "Kundprofil och kontaktuppgifter",
    delete_list_notes: "Anteckningar",
    delete_note_label: "Obs:",
    delete_note: "Banktransaktioner kopplas bort från kunden men bevaras (läsbara Open Banking-data).",
    delete_cancel: "Avbryt",
    delete_confirm: "Ta bort kund",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    status_pending: "Väntande",
    activity_new: "Ny",
    activity_awaiting_invoice: "Väntar på första fakturan",
    activity_active_days: "Aktiv för {{count}}d sedan",
    activity_days_ago: "{{count}}d sedan",
    activity_inactive_days: "Inaktiv {{count}}d",
    details: {
      back_to_clients: "Tillbaka till kunder",
      edit_client: "Redigera kund",
      subtitle: "Kunddetaljer och transaktionshistorik",
      total_revenue: "Totala intäkter",
      open_invoices: "Öppna fakturor",
      activity_status: "Aktivitetsstatus",
      basic_information: "Grundinformation",
      client_type: "Kundtyp",
      client_since: "Kund sedan",
      company_name: "Företagsnamn",
      last_invoice_date: "Datum för senaste faktura",
      type_individual: "Individ",
      type_company: "Företag",
      contact_information: "Kontaktinformation",
      email_address: "E-postadress",
      phone_number: "Telefonnummer",
      website: "Webbplats",
      not_provided: "Inte angivet",
      address_title: "Adress",
      address_location: "Plats",
      tax_information: "Skatteinformation",
      tax_id: "Skatte-ID / Moms",
      notes: "Anteckningar",
      no_notes: "Inga anteckningar",
      recent_transactions_title: "Senaste transaktioner",
      recent_transactions_description: "De senaste 5 banktransaktionerna för denna kund (Open Banking)",
      recent_transactions_loading: "Laddar transaktioner...",
      recent_transactions_empty: "Inga transaktioner att visa.",
      view_all_transactions: "Visa alla",
      transaction_fallback: "Banktransaktion",
      projects_title: "Projekt",
      projects_loading: "Laddar projekt...",
      projects_count: "{{count}} projekt kopplade till kunden",
      projects_empty: "Inga projekt ännu.",
      add_project: "Lägg till projekt",
      project_status_active: "Aktiv",
      project_status_completed: "Slutförd",
      project_status_on_hold: "Pausad",
      project_status_cancelled: "Avbruten",
      recent_activity_title: "Senaste aktivitet",
      recent_activity_description: "Senaste interaktioner och rörelser för kunden",
      activity_last_invoice_title: "Senaste faktura",
      activity_no_invoice_title: "Inga fakturor",
      activity_no_invoice_description: "Kunden har ännu inte fått några fakturor",
      activity_client_created_title: "Kund skapad",
      activity_days_ago: "{{count}} dagar sedan",
      activity_pending_title: "Ingen aktivitet ännu",
      activity_pending_description: "Kunden väntar på första fakturan",
      activity_inactive_description: "Kunden är inte längre aktiv",
      activity_none_title: "Ingen nylig aktivitet",
      activity_none_description: "Inga fakturor registrerade",
      activity_very_active_title: "Mycket aktiv",
      activity_active_title: "Aktiv",
      activity_moderate_title: "Måttlig aktivitet",
      activity_low_title: "Låg aktivitet",
      activity_last_invoice_days: "Senaste faktura för {{count}} dagar sedan",
      danger_zone_title: "Riskzon",
      danger_zone_description: "Oåterkalleliga åtgärder som kräver uppmärksamhet",
      danger_zone_action_title: "Ta bort denna kund",
      danger_zone_action_description: "Att ta bort en kund går inte att ångra. Profil, kontaktinformation och anteckningar tas bort. Banktransaktioner bevaras men kopplas bort.",
      danger_zone_action_button: "Ta bort kund",
    },
  },
  da: {
    title: "Kunder",
    subtitle: "Administrer kundeforhold og indtægter",
    add_client: "Tilføj kunde",
    revenue_overview_title: "Indtægtsoversigt",
    revenue_overview_description: "Følg indtægter og kundeaktivitet",
    period_select: "Vælg periode",
    period_last_7_days: "Seneste 7 dage",
    period_last_30_days: "Seneste 30 dage",
    period_this_month: "Denne måned",
    period_last_month: "Sidste måned",
    period_this_year: "Dette år",
    period_last_year: "Sidste år",
    period_all_time: "Hele perioden",
    metrics_total_revenue: "Samlet indtægt",
    metrics_avg_revenue: "Gns. pr. kunde",
    metrics_active_clients: "Aktive kunder",
    metrics_total_clients: "Kunder i alt",
    metrics_no_change: "Ingen ændring",
    metrics_vs_previous: "mod forrige",
    metrics_loading: "Indlæser...",
    toast_load_failed: "Kunne ikke indlæse kunder.",
    toast_delete_success_title: "Kunde slettet",
    toast_delete_success_description: "{{name}} er blevet slettet permanent.",
    toast_delete_failed: "Kunne ikke slette kunden.",
    search_placeholder: "Søg kunder efter navn, email eller lokation...",
    table_client: "Kunde",
    table_contact: "Kontakt",
    table_location: "Lokation",
    table_total_revenue: "Samlet indtægt",
    table_status: "Status",
    table_loading: "Indlæser kunder...",
    table_empty: "Ingen kunder endnu. Tilføj den første kunde.",
    table_action_view_details: "Se detaljer",
    table_action_edit: "Rediger kunde",
    table_action_view_transactions: "Se transaktioner",
    table_action_delete: "Slet kunde",
    delete_title: "Slet kunde?",
    delete_description: "Er du sikker på, at du vil slette {{name}}? Denne handling kan ikke fortrydes og fjerner:",
    delete_list_profile: "Kundeprofil og kontaktinfo",
    delete_list_notes: "Noter",
    delete_note_label: "Bemærk:",
    delete_note: "Banktransaktioner fjernes fra kunden men bevares (skrivebeskyttede Open Banking-data).",
    delete_cancel: "Annuller",
    delete_confirm: "Slet kunde",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    status_pending: "Afventer",
    activity_new: "Ny",
    activity_awaiting_invoice: "Afventer første faktura",
    activity_active_days: "Aktiv for {{count}}d siden",
    activity_days_ago: "{{count}}d siden",
    activity_inactive_days: "Inaktiv {{count}}d",
    details: {
      back_to_clients: "Tilbage til kunder",
      edit_client: "Rediger kunde",
      subtitle: "Kundedetaljer og transaktionshistorik",
      total_revenue: "Samlet indtægt",
      open_invoices: "Åbne fakturaer",
      activity_status: "Aktivitetsstatus",
      basic_information: "Grundlæggende oplysninger",
      client_type: "Kundetype",
      client_since: "Kunde siden",
      company_name: "Firmanavn",
      last_invoice_date: "Seneste fakturadato",
      type_individual: "Individuel",
      type_company: "Virksomhed",
      contact_information: "Kontaktoplysninger",
      email_address: "E-mailadresse",
      phone_number: "Telefonnummer",
      website: "Website",
      not_provided: "Ikke angivet",
      address_title: "Adresse",
      address_location: "Lokation",
      tax_information: "Skatteoplysninger",
      tax_id: "CVR / Moms",
      notes: "Noter",
      no_notes: "Ingen noter",
      recent_transactions_title: "Seneste transaktioner",
      recent_transactions_description: "Seneste 5 banktransaktioner for denne kunde (Open Banking)",
      recent_transactions_loading: "Indlæser transaktioner...",
      recent_transactions_empty: "Ingen transaktioner at vise.",
      view_all_transactions: "Se alle",
      transaction_fallback: "Banktransaktion",
      projects_title: "Projekter",
      projects_loading: "Indlæser projekter...",
      projects_count: "{{count}} projekt(er) tilknyttet kunden",
      projects_empty: "Ingen projekter endnu.",
      add_project: "Tilføj projekt",
      project_status_active: "Aktiv",
      project_status_completed: "Afsluttet",
      project_status_on_hold: "På hold",
      project_status_cancelled: "Annulleret",
      recent_activity_title: "Seneste aktivitet",
      recent_activity_description: "Seneste interaktioner og bevægelser for kunden",
      activity_last_invoice_title: "Seneste faktura",
      activity_no_invoice_title: "Ingen fakturaer",
      activity_no_invoice_description: "Kunden har endnu ikke modtaget fakturaer",
      activity_client_created_title: "Kunde oprettet",
      activity_days_ago: "{{count}} dage siden",
      activity_pending_title: "Ingen aktivitet endnu",
      activity_pending_description: "Kunden afventer første faktura",
      activity_inactive_description: "Kunden er ikke længere aktiv",
      activity_none_title: "Ingen nylig aktivitet",
      activity_none_description: "Ingen fakturaer registreret",
      activity_very_active_title: "Meget aktiv",
      activity_active_title: "Aktiv",
      activity_moderate_title: "Moderat aktivitet",
      activity_low_title: "Lav aktivitet",
      activity_last_invoice_days: "Seneste faktura for {{count}} dage siden",
      danger_zone_title: "Farezone",
      danger_zone_description: "Uigenkaldelige handlinger der kræver opmærksomhed",
      danger_zone_action_title: "Slet denne kunde",
      danger_zone_action_description: "Sletning er uigenkaldelig. Profil, kontaktinfo og noter fjernes. Banktransaktioner bevares men frakobles.",
      danger_zone_action_button: "Slet kunde",
    },
  },
  fi: {
    title: "Asiakkaat",
    subtitle: "Hallitse asiakassuhteita ja tuloja",
    add_client: "Lisää asiakas",
    revenue_overview_title: "Tulojen yhteenveto",
    revenue_overview_description: "Seuraa tuloja ja asiakasaktiivisuutta",
    period_select: "Valitse ajanjakso",
    period_last_7_days: "Viimeiset 7 päivää",
    period_last_30_days: "Viimeiset 30 päivää",
    period_this_month: "Tämä kuukausi",
    period_last_month: "Viime kuukausi",
    period_this_year: "Tämä vuosi",
    period_last_year: "Viime vuosi",
    period_all_time: "Koko ajanjakso",
    metrics_total_revenue: "Kokonaismyynti",
    metrics_avg_revenue: "Keskiarvo per asiakas",
    metrics_active_clients: "Aktiiviset asiakkaat",
    metrics_total_clients: "Asiakkaita yhteensä",
    metrics_no_change: "Ei muutosta",
    metrics_vs_previous: "vs. edellinen",
    metrics_loading: "Ladataan...",
    toast_load_failed: "Asiakkaiden lataaminen epäonnistui.",
    toast_delete_success_title: "Asiakas poistettu",
    toast_delete_success_description: "{{name}} on poistettu pysyvästi.",
    toast_delete_failed: "Asiakkaan poistaminen epäonnistui.",
    search_placeholder: "Hae asiakkaita nimen, sähköpostin tai sijainnin mukaan...",
    table_client: "Asiakas",
    table_contact: "Yhteystiedot",
    table_location: "Sijainti",
    table_total_revenue: "Kokonaismyynti",
    table_status: "Tila",
    table_loading: "Ladataan asiakkaita...",
    table_empty: "Ei asiakkaita vielä. Lisää ensimmäinen asiakas.",
    table_action_view_details: "Näytä tiedot",
    table_action_edit: "Muokkaa asiakasta",
    table_action_view_transactions: "Näytä tapahtumat",
    table_action_delete: "Poista asiakas",
    delete_title: "Poistetaanko asiakas?",
    delete_description: "Haluatko varmasti poistaa {{name}}? Tämä toiminto on peruuttamaton ja poistaa:",
    delete_list_profile: "Asiakasprofiilin ja yhteystiedot",
    delete_list_notes: "Muistiinpanot",
    delete_note_label: "Huom:",
    delete_note: "Pankkitapahtumat irrotetaan asiakkaasta mutta säilytetään (vain luku - Open Banking).",
    delete_cancel: "Peruuta",
    delete_confirm: "Poista asiakas",
    status_active: "Aktiivinen",
    status_inactive: "Ei aktiivinen",
    status_pending: "Odottaa",
    activity_new: "Uusi",
    activity_awaiting_invoice: "Odottaa ensimmäistä laskua",
    activity_active_days: "Aktiivinen {{count}}p sitten",
    activity_days_ago: "{{count}}p sitten",
    activity_inactive_days: "Ei aktiivinen {{count}}p",
    details: {
      back_to_clients: "Takaisin asiakkaisiin",
      edit_client: "Muokkaa asiakasta",
      subtitle: "Asiakkaan tiedot ja tapahtumahistoria",
      total_revenue: "Kokonaismyynti",
      open_invoices: "Avoimet laskut",
      activity_status: "Aktiviteetin tila",
      basic_information: "Perustiedot",
      client_type: "Asiakastyyppi",
      client_since: "Asiakas alkaen",
      company_name: "Yrityksen nimi",
      last_invoice_date: "Viimeisin laskun päivämäärä",
      type_individual: "Yksityinen",
      type_company: "Yritys",
      contact_information: "Yhteystiedot",
      email_address: "Sähköpostiosoite",
      phone_number: "Puhelin",
      website: "Verkkosivu",
      not_provided: "Ei annettu",
      address_title: "Osoite",
      address_location: "Sijainti",
      tax_information: "Veroasiat",
      tax_id: "Verotunnus / ALV",
      notes: "Muistiinpanot",
      no_notes: "Ei muistiinpanoja",
      recent_transactions_title: "Viimeisimmät tapahtumat",
      recent_transactions_description: "Viimeiset 5 pankkitapahtumaa tästä asiakkaasta (Open Banking)",
      recent_transactions_loading: "Ladataan tapahtumia...",
      recent_transactions_empty: "Ei tapahtumia näytettäväksi.",
      view_all_transactions: "Näytä kaikki",
      transaction_fallback: "Pankkitapahtuma",
      projects_title: "Projektit",
      projects_loading: "Ladataan projekteja...",
      projects_count: "{{count}} projekti(a) liittyy tähän asiakkaaseen",
      projects_empty: "Ei projekteja vielä.",
      add_project: "Lisää projekti",
      project_status_active: "Aktiivinen",
      project_status_completed: "Valmis",
      project_status_on_hold: "Tauolla",
      project_status_cancelled: "Peruutettu",
      recent_activity_title: "Viimeisin aktiivisuus",
      recent_activity_description: "Viimeisimmät asiakkaan vuorovaikutukset ja tapahtumat",
      activity_last_invoice_title: "Viimeisin lasku",
      activity_no_invoice_title: "Ei laskuja",
      activity_no_invoice_description: "Tälle asiakkaalle ei ole vielä lähetetty laskuja",
      activity_client_created_title: "Asiakas luotu",
      activity_days_ago: "{{count}} päivää sitten",
      activity_pending_title: "Ei vielä aktiivisuutta",
      activity_pending_description: "Asiakas odottaa ensimmäistä laskua",
      activity_inactive_description: "Asiakas ei ole enää aktiivinen",
      activity_none_title: "Ei viimeaikaista aktiivisuutta",
      activity_none_description: "Laskuja ei ole kirjattu",
      activity_very_active_title: "Erittäin aktiivinen",
      activity_active_title: "Aktiivinen",
      activity_moderate_title: "Kohtalainen aktiivisuus",
      activity_low_title: "Vähäinen aktiivisuus",
      activity_last_invoice_days: "Viimeisin lasku {{count}} päivää sitten",
      danger_zone_title: "Vaaravyöhyke",
      danger_zone_description: "Peruuttamattomat toiminnot, jotka vaativat huomiota",
      danger_zone_action_title: "Poista tämä asiakas",
      danger_zone_action_description: "Poistaminen on peruuttamaton. Profiili, yhteystiedot ja muistiinpanot poistetaan. Pankkitapahtumat säilytetään mutta irrotetaan.",
      danger_zone_action_button: "Poista asiakas",
    },
  },
};
